import { Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { WfIconContentArrowRightRegular } from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";

interface HistoricalFitnessProfile4DPProps {
  ftp?: number;
  map?: number;
  ac?: number;
  nm?: number;
  previousFtp?: number;
  previousMap?: number;
  previousAc?: number;
  previousNm?: number;
}

const HistoricalFitnessProfile4DP = ({
  ftp,
  map,
  ac,
  nm,
  previousFtp,
  previousMap,
  previousAc,
  previousNm,
}: HistoricalFitnessProfile4DPProps) => {
  const { palette } = useTheme();
  const FourDPItems = [
    {
      id: "ftp",
      name: "FTP",
      time: t`60 min`,
      colorStart: palette.zones["4dp"].ftp.gradientStart,
      colorEnd: palette.zones["4dp"].ftp.gradientEnd,
      value: ftp,
      previousValue: previousFtp,
    },
    {
      id: "map",
      name: "MAP",
      time: t`5 min`,
      colorStart: palette.zones["4dp"].map.gradientStart,
      colorEnd: palette.zones["4dp"].map.gradientEnd,
      value: map,
      previousValue: previousMap,
    },
    {
      id: "ac",
      name: "AC",
      time: t`1 min`,
      colorStart: palette.zones["4dp"].ac.gradientStart,
      colorEnd: palette.zones["4dp"].ac.gradientEnd,
      value: ac,
      previousValue: previousAc,
    },
    {
      id: "nm",
      name: "NM",
      time: t`5 sec`,
      colorStart: palette.zones["4dp"].nm.gradientStart,
      colorEnd: palette.zones["4dp"].nm.gradientEnd,
      value: nm,
      previousValue: previousNm,
    },
  ];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {FourDPItems.map((item) => {
        if (!item.value) return null;
        return (
          <Box
            key={item.id}
            display="flex"
            alignItems="center"
            width="100%"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                borderRadius="50%"
                border={`1px solid ${palette.background.level1}`}
                width={12}
                height={12}
                sx={{
                  background: `linear-gradient(to left, ${item.colorStart}, ${item.colorEnd})`,
                }}
              />
              <Box display="flex" flexDirection="row" gap={0.5}>
                <Typography variant="prose-sm-medium">{item.name}</Typography>
                <Typography variant="prose-sm-medium" color="text.secondary">
                  {item.time}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" gap={0.5}>
              {item.previousValue && item.previousValue !== item.value && (
                <>
                  <Typography variant="prose-sm-medium">{item.previousValue} W</Typography>
                  <WfIconContentArrowRightRegular
                    fontSize="small"
                    color={item.value > item.previousValue ? "success" : "error"}
                  />
                </>
              )}
              <Typography variant="prose-sm-medium">{item.value} W</Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default HistoricalFitnessProfile4DP;
